export default __webpack_public_path__ + "static/media/arrow-right.a617d0ee.svg";